module.exports = __webpack_public_path__ + "img/pablo-hero.6d18020a.jpg";